import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Content = styled.div`
  position: relative;

  .chakra-table__container {
    overflow: visible !important; /* Allow dropdowns to overflow */
    position: relative;

    /* Force dropdowns to render above everything */
    .chakra-menu__menu,
    .chakra-menu__menu-list {
      z-index: 99999 !important;
      position: fixed !important;
      overflow: visible !important;
    }
  }
`;

export const Centered = styled.div`
  display: flex;
  align-items: center;
`;

export const TableLink = styled(Link)`
  color: #054ad9;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

export const CustomUserInitials = styled.div<{
  size: number;
  pictureUrl: string;
  firstName: string;
  lastName: string;
}>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 50%;
  background: ${(props) =>
    props.pictureUrl ? `url(${props.pictureUrl}) center/cover` : '#e2e8f0'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #4a5568;
  margin-right: 12px;

  &::before {
    content: '${(props) =>
      props.pictureUrl ? '' : `${props.firstName.charAt(0)}${props.lastName.charAt(0)}`}';
  }
`;

export const CustomTechStackBadge = styled.span<{ willingToReview?: boolean }>`
  display: inline-block;
  background: ${(props) => (props.willingToReview === false ? '#fef2f2' : '#f7fafc')};
  border: 1px solid ${(props) => (props.willingToReview === false ? '#fecaca' : '#e2e8f0')};
  color: ${(props) => (props.willingToReview === false ? '#991b1b' : '#4a5568')};
  border-radius: 4px;
  padding: 2px 8px;
  margin: 2px;
  font-size: 12px;
  white-space: nowrap;

  &:not(:last-of-type) {
    margin-right: 6px;
  }
`;

export const NotFound = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #fff;
  height: 410px;
  color: #718096;

  p {
    margin-bottom: 24px;
  }
`;

export const NotFoundSubtitle = styled.p`
  font-size: 26px;
  line-height: 30px;
  font-weight: 600;
  color: #2d3748;
`;
